import { useMutation } from '@tanstack/react-query';
import {
  type PriceListCreateError,
  PriceListError,
  priceListBuilderToPriceList,
  templateToBuilderState,
  useCreatePriceList,
  usePriceListTemplates,
} from '../../../../price-lists';

/**
 * Creates the seeded template price list at the chosen discount. Created but not assigned — wiring it
 * to a customer group is the separate assignment step.
 */
export function useCreateTemplatePriceList() {
  const [template] = usePriceListTemplates();
  const createPriceList = useCreatePriceList();

  return useMutation<void, PriceListCreateError, number>({
    // Reuse the builder's transform so a one-click list is identical to one made in the full builder.
    mutationFn: async (discount) => {
      if (!template) {
        throw new PriceListError('create_failed');
      }
      const priceList = priceListBuilderToPriceList(templateToBuilderState(template, discount));
      await createPriceList.mutateAsync({ priceList });
    },
  });
}
